<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-add-member-class-school"
            @hidden="resetModal">
            <div class="container wrap-form-save-class-school">
                <h4 class="title-header">
                    <strong>Thêm học sinh</strong>
                </h4>
                <div class="row padding-left-20 padding-right-20">
                    <div class="col-md-4">
                        <label class="label-form" for="userId">Nhập ID học sinh:</label>
                    </div>
                    <div class="col-md-8">
                        <b-form-input placeholder="Nhập id của học sinh" id="userId" type="text"
                            v-model="userId"></b-form-input>
                    </div>
                </div>
                <div class="custom-line">
                    <div class="line1">

                    </div>
                    <div class="text-line">
                        hoặc
                    </div>
                    <div class="line1">

                    </div>
                </div>
                <div class="row padding-left-20 padding-right-20">
                    <div class="col-md-6">
                        <label for="code">Mã lớp:</label>
                    </div>
                    <div class="col-md-6">
                        <label for="password">Mật khẩu:</label>

                    </div>
                    <div class="col-md-6">
                        <strong class="code">
                            {{ form.code }}
                        </strong>
                    </div>
                    <div class="col-md-6">
                        <strong class="password">
                            {{ form.password }}

                        </strong>
                    </div>

                </div>

                <div class="row padding-left-20 padding-right-20">
                    <!-- <div class="col-md-6">
                            <b-button class="btn-copy" @click="handleCopyCode">
                                <img class="icon-copy" src="@/assets/img/copy.png" />
                                Sao chép mã
                            </b-button>
                        </div> -->
                    <div class="col-md-12">
                        <b-button class="btn-copy" @click="handleCopyCodeAndPass">
                            <img class="icon-copy" src="@/assets/img/copy.png" />
                            Sao chép mã và mật khẩu
                        </b-button>
                    </div>
                </div>
                <div class="col-md-12">

                    <b-button class="btn-copy btn-copy-link" @click="handleCopyLinkJoin">
                        <img class="icon-link" src="@/assets/img/link.png" />
                        Sao chép đường liên kết
                    </b-button>
                </div>
                <div class="form_action display-flex justity-content-space-around">
                    <button type="button"
                        class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                        :disabled="isLoading" @click="handleHideModal">
                        Hủy
                    </button>
                    <button type="button"
                        class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                        :disabled="isLoading" @click="handleAddMember">
                        Thêm mới
                    </button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { getDetail } from './../_api/classSchoolServices'
import { saveClassSchoolUser } from './../_api/classSchoolUserServices'
import { APP_CONFIG } from "@/utils/constants";
import copy from 'copy-to-clipboard';
export default {
    name: "ModalAddMemberClassSchool",
    props: {
        classSchoolId: {
            type: Number,
            default: 0
        }
    },
    components: {
    },
    data() {
        return {
            userId: '',
            confirmActive: {},
            submitted: false,
            isLoading: false,
            domain: APP_CONFIG.domain,
            form: {
                id: 0,
                nameSchool: '',
                code: '',
                name: '',
                password: '',
                classId: '',
                subjectId: '',

            }
        }
    },

    computed: {
        screenWidth() {
            return window.innerWidth;
        },
    },
    mounted() {
        this.handleShowModal()
        if (this.classSchoolId > 0) {
            this.getDetailClassSchool()
        }
    },

    methods: {
        handleCopyPass() {
            this.copyToClipboard(this.form.password)
        },
        handleCopyCode() {
            this.copyToClipboard(this.form.code)
        },
        handleCopyCodeAndPass() {
            let text = `Mã lớp:${this.form.code} Mật khẩu:${this.form.password}`
            this.copyToClipboard(text)
        },
        getDetailClassSchool() {
            let self = this
            getDetail(this.classSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.form = {
                        id: res.data.id,
                        nameSchool: res.data.nameSchool,
                        code: res.data.code,
                        name: res.data.name,
                        password: res.data.password,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                    }
                }
            })
        },
        handleAddMember() {
            let self = this
            let data = {
                userId: this.userId,
                classSchoolId: this.classSchoolId
            }
            // thêm
            if (!data.userId.trim()) {
                self.$toast.success('Vui lòng nhập ID của học sinh')
            } else {
                saveClassSchoolUser(data).then((res) => {
                    if (res && !res.errors) {
                        self.$toast.success(res.message)
                        this.userId = ''
                        this.handleDone()
                    }
                })
            }
        },
        handleCopyLinkJoin() {
            let linkJoin = `${this.domain}/tham-gia-lop-hoc`
            this.copyToClipboard(linkJoin)
        },
        copyToClipboard(text) {
            copy(text, {
                debug: true,
                message: 'Press #{key} to copy',
            });
        },
        handleDone() {
            //this.handleHideModal()
            this.$emit('handleDone')
        },
        handleSave() {

        },
        resetModal() {

        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-add-member-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-add-member-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-add-member-class-school'].show()
        },
    }
}
</script>

<style lang="scss" scoped>
.btn-copy {

    // margin: 5px 0px 5px 0px;
    // background: white;
    // color: black;
    // border: 1px solid #d5d2d2;
    .icon-copy,
    .icon-link {
        width: 20px;
    }
}

.custom-line {
    display: flex;
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .line1 {
        width: 100%;
        height: 2px;
        background: #e5e5e5;
    }

    .line2 {
        width: 100%;
        height: 2px;
        background: #e5e5e5;
    }

    .text-line {
        margin-top: -10px;
        padding-left: 10px;
        padding-right: 10px;
        color: #e5e5e5;
    }
}

.icon-link {
    width: 20px;
}

.padding-left-20 {
    padding-left: 20px;
}

.padding-right-20 {
    padding-right: 20px;
}

.btn-copy {
    margin: 5px 0px 5px 0px;
    background: white;
    color: black;
    border: 1px solid #d5d2d2;
    width: 100%;
}

.label-form {
    font-size: 14px;
}

.text-center {
    text-align: center;
}

.modal-content {
    background-color: red;
}

.wrap-form-save-class-school {
    padding-top: 20px;
    background-color: white;
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-around {
    justify-content: space-around
}
</style>